export interface CalculatorField {
  label: string;
  hint?: string;
}

/** Raw field values keyed by label; parsed by each calculator's math module. */
export type CalculatorFieldValues = Record<string, string>;

export const mapFieldValues = (
  values: CalculatorFieldValues,
  transform: (raw: string, label: string) => string,
): CalculatorFieldValues =>
  Object.fromEntries(Object.entries(values).map(([label, raw]) => [label, transform(raw, label)]));

/** Missing keys are valid fields. */
export type CalculatorFieldErrors = Partial<Record<string, string>>;
